<template lang="pug">
.vue-calendar(v-if="current")
  .row.between(style="margin-top: -12px;padding: 12px;")
    .month.row.center.between
      .row.center.chevron-container(:class="{inactive: this.domain && current.format('%Y-%m') === new Date(domain[0]).format('%Y-%m')}" @click="rewind('1 month')")
        .row.center.chevron
          font-awesome-icon.row.center(icon="chevron-left")
      .row.center.value {{ current.format('{month}').capitalize() }}
      .row.center.chevron-container(:class="{inactive: this.domain && current.format('%Y-%m') === new Date(domain[1]).format('%Y-%m')}" @click="advance('1 month')")
        .row.center.chevron
          font-awesome-icon.row.center(icon="chevron-right")
    .year.row.center.between
      .row.center.chevron-container(:class="{inactive: this.domain && current.format('%Y') === new Date(domain[0]).format('%Y')}" @click="rewind('1 year')")
        .row.center.chevron
          font-awesome-icon(icon="chevron-left")
      .row.center.value {{ current.format("{year}") }}
      .row.center.chevron-container(:class="{inactive: this.domain && current.format('%Y') === new Date(domain[1]).format('%Y')}" @click="advance('1 year')")
        .row.center.chevron
          font-awesome-icon(icon="chevron-right")
  .calendar
    .week
      .day(v-for="weekday in weekdays") {{ weekday }}
    .week(v-for="week in weeks")
      .day(v-for="day in week" :class="{disabled: is_disabled(current_month, day), active: (active && new Date(active).format('%Y-%m') === current.format('%Y-%m') && new Date(active).format('{d}') == day)}" @click="select_day(day)") {{ day }}
</template>
<script>
export default {
  props: ['domain', 'active'],
  data() {
    return {
      weekdays: ['L', 'M', 'M', 'J', 'V', 'S', 'D'],
      current: this.active ? new Date(this.active) : new Date()
    }
  },
  computed: {
    current_month() {
      return this.current.format('%Y-%m')
    },
    string_domain() {
      return this.domain && this.domain.map(d => new Date(d).format('%Y-%m-%d'))
    },
    months() {
      const months = Sugar.Date.getLocale(this.$root.lang).months
      return months.slice(0, 12).map((v, i) => months[12 + i] || v)
    },
    weeks() {
      const lastday = this.current.clone().rewind('1 month').endOfMonth().getDate()
      const dow = (this.current.clone().beginningOfMonth().getDay() || 7) - 1
      const days = this.current.daysInMonth()
      const start = (1 + lastday - dow) > lastday ? [] : (1 + lastday - dow).upto(lastday).map(d => null)
      const middle = (1).upto(days)
      const end = (1).upto(7 - (dow + days) % 7).map(d => null)
      return [].concat(start, middle, end).chunk(7)
    },
  },
  methods: {
    is_disabled(month,day) {
      const date = month + '-'+(''+day).padStart(2,'0')
      if (date < this.string_domain[0]) return true
      return false
    },
    select_day(day) {
      const date = this.current.format('%Y-%m-') + (''+day).padStart(2,'0')
      this.$emit('select', date)
    },
    rewind(period) {
      const newDate = new Date(this.current).rewind(period)
      if (this.domain && newDate < new Date(this.domain[0])) return this.current = new Date(this.domain[0])
      this.current = newDate
    },
    advance(period) {
      const newDate = new Date(this.current).advance(period)
      if (this.domain && newDate > new Date(this.domain[1])) return this.current = new Date(this.domain[1])
      this.current = newDate
    }
  }
}
</script>
<style>
.vue-calendar { width: 280px;padding: 12px; background: white;border-radius: 4px; }
.vue-calendar .calendar { line-height: 2.6;}
.vue-calendar .day:hover { cursor: pointer;background: rgba(0, 0, 0, .1); }
.vue-calendar .week:nth-child(1) { pointer-events: none;color: var(--primary); font-size: 12px; }
.vue-calendar .week { display: flex;align-items: center;justify-content: center;font-size: 12px; }
.vue-calendar .day { flex: 1;text-align: center; border-radius: 4px;}
.vue-calendar .day.active { color: white;background: var(--primary); opacity: 0.7; }
.vue-calendar .day.disabled { pointer-events: none; color: var(--inactive);font-weight: 400;}
.vue-calendar .month { min-width: 120px; }
.vue-calendar .month .value { min-width: 76px; }
.vue-calendar .year { min-width: 90px; }
.vue-calendar .year .value { min-width: 38px; }
.vue-calendar .month, .vue-calendar .year { font-size: 14px; }
.vue-calendar .chevron-container { flex:1; }
.vue-calendar .chevron-container.inactive { pointer-events: none; color: var(--inactive);}
/* .vue-calendar .chevron-container.inactive .{} */
.vue-calendar .chevron { height: 26px;width: 26px; border-radius: 50%;}
.vue-calendar .chevron-container:hover { cursor: pointer; }
.vue-calendar .chevron-container:hover .chevron { background: rgba(0,0,0,0.1); }
.vue-calendar .chevron svg { height: 20px;width: 20px; }
</style>
